






























































import { Component, Vue } from 'vue-property-decorator';
import SimpleCompanySearch from '@/components/common/SimpleCompanySearch.vue';
import PortalSelect from '@/components/new_style_components/PortalSelect.vue';
import PaginationComponent from '@/components/util/PaginationComponent.vue';
import SubscriptionService from '@/services/SubscriptionService';
import Page, { EMPTY_PAGE } from '@/dto/taxation/Page';
import SublimeChargeDTO from '@/dto/subscription/SublimeChargeDTO';
import SelectOption, { OptionsBuilder } from '@/components/common/SelectOption';
import { processError } from '@/utils/ComponentUtils';

@Component({
  components: { SimpleCompanySearch, PortalSelect, PaginationComponent },
})
export default class SublimeCharges extends Vue {
  private loading = false;
  private pageSize = 20;
  private charges: Page<SublimeChargeDTO> = { ...EMPTY_PAGE };

  private selectedCompany: { id: number } | null = null;
  private issuer: string | null = null; // SA, SPS, SC, SPJ

  private formatCents(cents: number | null | undefined): string {
    if (cents === null || cents === undefined) return '';
    const dollars = cents / 100;
    // Keep exactly two decimals; avoid locale dependency
    return `$${dollars.toFixed(2)}`;
  }

  get issuerOptions(): Array<SelectOption> {
    return new OptionsBuilder()
      .of('Sublime Accounting Inc', 'SA')
      .of('Sublime Payroll Services Inc', 'SPS')
      .of('Sublime Consulting Inc', 'SC')
      .of('Sublime Projects Inc', 'SPJ')
      .get();
  }

  mounted() {
    // Do not load initially until both filters are selected
  }

  private onFilterChange = () => {
    this.changePage(1);
  }

  private changePage(page: number) {
    this.load(page - 1);
  }

  private load(pageNumber = 0) {
    // Send request only if both filters (company and issuer) are selected
    if (!this.selectedCompany?.id || !this.issuer) {
      // reset page to empty and stop loading
      this.charges = { ...EMPTY_PAGE } as Page<SublimeChargeDTO>;
      this.loading = false;
      return;
    }
    this.loading = true;
    SubscriptionService.getCharges(pageNumber, this.pageSize, this.selectedCompany?.id, this.issuer).then(
      ok => {
        this.charges = ok.data;
        this.loading = false;
      },
      err => {
        this.loading = false;
        processError(err, this);
      }
    );
  }
}
